<template>
  <div class="product-finder">
    <Input v-model="valueInput" disabled>
      <Button slot="append" icon="ios-search" @click="handleInputClicked"></Button>
    </Input>
    <div class="text-align-right" style="font-size: 12px; color: rgb(128, 134, 149);" v-if="product && product.id"><a :href="`/products/${product.id}`" target="_blank">{{ $t('product.click_here_to_view_product') }}</a></div>
    <Modal v-model="showFinder" title="Find a product" :width="width">
      <ProductListWithFilter ref="productListWithFilter" @on-selected="handleSelected"></ProductListWithFilter>
    </Modal>
  </div>
</template>

<script>
import ProductListWithFilter from './product-list-with-filter'
export default {
  name: "ProductFinder",
  components: {
    ProductListWithFilter
  },
  props: {
    width: {
      type: [String, Number],
      default: 800
    },
    value: Number,
    product: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      valueInput: '',
      showFinder: false
    }
  },
  mounted () {
    this.valueInput = this.product?.product_name
  },
  methods: {
    handleInputClicked () {
      this.showFinder = true
      this.$refs['productListWithFilter'].findProducts()
    },
    handleSelected (row) {
      this.showFinder = false
      this.valueInput = row.product_name
      this.$emit('update:product', row)
      this.$emit('input', row.id)
      this.$emit('selected', row)
    }
  },
  watch: {
    value () {
      this.valueInput = this.product?.product_name
    }
  }
}
</script>
